import {ofType} from 'redux-observable';
import {of, zip} from 'rxjs';
import {flatMap, mergeMap} from 'rxjs/operators';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import * as AccountDetailEpics from 'web-app/react/account-settings/account-details/epics';
import * as GlobalEventActions from 'web-app/react/global-event/actions';

import * as API from './api';
import * as Actions from './actions';

const getTwoFactorImage = action$ =>
    action$.pipe(
        ofType(Actions.getTwoFactorImage.type),
        mergeMap(({payload}) =>
            API.getTwoFactorImage(payload.accessToken)
                .map(({imageUrl, secret}) => Actions.getTwoFactorImageSuccess.action(imageUrl, secret))
                .catch(e => of(Actions.getTwoFactorImageFailed.action(e))),
        ),
    );

const activateTwoFactor = action$ =>
    action$.pipe(
        ofType(Actions.activateTwoFactor.type),
        mergeMap(({payload}) =>
            API.activateTwoFactor(payload.accessToken, payload.secret, payload.code)
                .mergeMap(() => {
                    return zip(
                        AccountDetailEpics.fetchAccountDetailsObservable(),
                        of(Actions.activateTwoFactorSuccess.action()),
                        of(
                            GlobalEventActions.updateSuccess.action(
                                i18next.t('account.twoFactorSettings.twoFactorEnabled'),
                            ),
                        ),
                    ).pipe(flatMap(actions => actions));
                })
                .catch(e => of(Actions.activateTwoFactorFailed.action(e))),
        ),
    );

const disableTwoFactor = action$ =>
    action$.pipe(
        ofType(Actions.disableTwoFactor.type),
        mergeMap(({payload}) =>
            API.disableTwoFactor(payload.accessToken, payload.password)
                .mergeMap(() => {
                    return AccountDetailEpics.fetchAccountDetailsObservable().pipe(
                        flatMap(action => [
                            action,
                            Actions.disableTwoFactorSuccess.action(),
                            Actions.getTwoFactorImage.action(payload.accessToken),
                            GlobalEventActions.updateSuccess.action(
                                i18next.t('account.twoFactorSettings.twoFactorDisabled'),
                            ),
                        ]),
                    );
                })
                .catch(e => of(Actions.disableTwoFactorFailed.action(e))),
        ),
    );

export default combineEpics(getTwoFactorImage, activateTwoFactor, disableTwoFactor);
